/**
 * Formats a latitude as Figma Point details (`39.739234° N`).
 */
export function formatLatitude(latitude: number): string {
	const direction = latitude >= 0 ? "N" : "S";
	return `${Math.abs(latitude).toFixed(6)}° ${direction}`;
}

/**
 * Formats a longitude as Figma Point details (`104.990003° W`).
 */
export function formatLongitude(longitude: number): string {
	const direction = longitude >= 0 ? "E" : "W";
	return `${Math.abs(longitude).toFixed(6)}° ${direction}`;
}
